import React, { useEffect, useRef } from 'react';
import { RESOURCE_LINKS } from './siteConfig';
import { NAV_LINKS, ThemeToggle } from './MarketingHeader';

export const MobileDrawer = ({ onNav, onAuth, theme, onToggleTheme, onClose }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.querySelector('a')?.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div id="mk-drawer" className="mk-drawer" ref={ref} data-testid="mobile-menu">
      <a className="mk-btn mk-btn-primary mk-btn-block" href="/?auth=signup" onClick={(e) => onAuth(e, 'signup')} data-testid="mobile-start-trial">
        Start Free Trial
      </a>
      <nav aria-label="Mobile" className="mk-drawer-nav">
        {NAV_LINKS.map((l) => (
          <a key={l.href} href={l.href} onClick={(e) => onNav(e, l)} data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}>{l.label}</a>
        ))}
        <p className="mk-drawer-sub">Resources</p>
        {RESOURCE_LINKS.map((r) => <a key={r.href} href={r.href} data-testid={`mobile-resource-${r.href.slice(1)}`}>{r.label}</a>)}
      </nav>
      <div className="mk-drawer-foot">
        <a className="mk-btn mk-btn-ghost mk-btn-block" href="/?auth=login" onClick={(e) => onAuth(e, 'login')} data-testid="mobile-signin">Sign In</a>
        <ThemeToggle theme={theme} onToggle={onToggleTheme} testId="mobile-theme-toggle" />
      </div>
    </div>
  );
};
